import { render, staticRenderFns } from "./crm.vue?vue&type=template&id=6a77aa3c&scoped=true&"
import script from "./crm.vue?vue&type=script&lang=js&"
export * from "./crm.vue?vue&type=script&lang=js&"
import style0 from "./crm.vue?vue&type=style&index=0&id=6a77aa3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a77aa3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
